import {
  Badge,
  Cushion,
  FlexContainer,
  Grid,
  Image,
  Rectangle,
  Typography,
} from '@pitchero/react-ui';
import { DateTime } from 'luxon';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import Icon from '../icon';
import CLUB_PROP_TYPES from '../../lib/prop-types/club';
import ClubLink from '../club-link';
import { getClubTeam } from '../../store/clubs/selectors';

const TrainingSession = ({ session, club, isLast, teams }) => {
  // Renders the row for each side, with logo/badge, team name
  const renderSideRow = (
    <Grid columns="36px 1fr" columnGap="10px" alignItems="center">
      {club.logo ? (
        <Image src={club.logo} alt={club.name} height={36} width={36} transformation="square" />
      ) : (
        <Badge size="36" />
      )}
      <FlexContainer flexDirection="column" style={{ gap: '5px' }} justifyContent="center">
        <Typography preset="document" size={14}>
          {session.title}
        </Typography>
        {teams && teams.length > 0 && (
          <Typography preset="description" size={12} color="dustygray">
            {teams
              .filter(Boolean) // Remove null or undefined teams
              .map((team) => team?.name)
              .join(', ')}
          </Typography>
        )}
      </FlexContainer>
    </Grid>
  );

  return (
    <ClubLink route="calendar.training" params={{ id: session.id }}>
      <a>
        <FlexContainer
          flexDirection="column"
          style={{
            minHeight: '150px',
            backgroundColor: '#fff',
            boxSizing: 'border-box',
            borderBottom: isLast ? 'none' : '1px solid #d9d9d9',
            padding: '16px',
          }}
          component="div"
        >
          <FlexContainer
            justifyContent="space-between"
            alignItems="center"
            style={{ paddingBottom: '20px' }}
          >
            <Rectangle fill="#EDF1F7" radius="rounded">
              <Cushion all="xsmall">
                <Typography color="#46689F" size={14} weight={600} transform="uppercase">
                  Training
                </Typography>
              </Cushion>
            </Rectangle>
            <Typography size={14} color="#666">
              {`${DateTime.fromISO(session.start).setZone(club.timezone).toFormat('HH:mm')}
               - ${DateTime.fromISO(session.end).setZone(club.timezone).toFormat('HH:mm')}`}
            </Typography>
          </FlexContainer>
          <FlexContainer
            flexDirection="column"
            justifyContent="center"
            style={{ height: '100%', margin: 'auto 0' }}
          >
            <Grid columns="1fr auto" rowGap="small">
              <Grid alignItems="center" alignContent="center" style={{ paddingRight: '5px' }}>
                {renderSideRow}
              </Grid>
              <Grid columns="1fr 20px" alignItems="center" justifyContent="end" columnGap="5px">
                <Typography preset="body--small" color="#000" />
                <Icon name="arrow-right" color="gray" size={16} />
              </Grid>
            </Grid>
          </FlexContainer>
        </FlexContainer>
      </a>
    </ClubLink>
  );
};

TrainingSession.propTypes = {
  session: PropTypes.shape({
    end: PropTypes.string,
    id: PropTypes.number,
    isCancelled: PropTypes.bool,
    sortType: PropTypes.string,
    start: PropTypes.string,
    teamIds: PropTypes.arrayOf(PropTypes.number),
    title: PropTypes.string,
  }).isRequired,
  club: CLUB_PROP_TYPES.isRequired,
  isLast: PropTypes.bool,
  teams: PropTypes.arrayOf(PropTypes.shape()),
};

TrainingSession.defaultProps = {
  isLast: false,
  teams: [],
};

const mapStateToProps = (state, ownProps) => ({
  teams: ownProps.session.teamIds?.map((teamId) => getClubTeam(state, ownProps.club.id, teamId)),
});

export default connect(mapStateToProps)(TrainingSession);
